export default __webpack_public_path__ + "static/media/(95).d5dcc2fa.jpg";